import { Reveal } from "./Reveal";
import { Check } from "lucide-react";

const steps = [
  { n: "1", text: "Il laboratorio realizza le dime radiologiche: mascherine trasparenti da indossare durante la TAC." },
  { n: "2", text: "La TAC 3D permette di riprodurre l'anatomia ossea e progettare digitalmente una soluzione su misura." },
  { n: "3", text: "Il progetto prende forma: una griglia implantare in titanio personalizzata, ancorata sulla superficie esterna dell'osso." },
  { n: "4", text: "Con un unico intervento la griglia viene fissata e la protesi fissa provvisoria inserita il giorno stesso." },
  { n: "5", text: "Dopo circa 3–4 mesi viene consegnata la protesi fissa definitiva." },
];

const advantages = [
  "Griglie in titanio personalizzate: precisione e sicurezza",
  "Titanio biocompatibile, senza fenomeni allergici",
  "Sedazione analgesica controllata: nessun dolore",
  "Convenzione con struttura in Day Surgery per l'anestesia generale",
  "Addio alla dentiera, anche senza osso",
];

export const BoneSection = () => (
  <section id="poco-osso" className="py-24 md:py-32 px-6 md:px-12 bg-[#DDEBF2]" data-testid="bone-section">
    <div className="max-w-7xl mx-auto">
      <div className="grid lg:grid-cols-[1.1fr_1fr] gap-14 items-start">
        <div>
          <Reveal>
            <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#7D9285] mb-4">Chirurgia iuxtaossea</p>
            <h2 className="font-serif-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#15201A]">
              Impianti dentali con poco osso: ti hanno detto che <em className="italic text-[#385244]">non hai osso?</em>
            </h2>
            <p className="mt-6 text-base md:text-lg leading-relaxed text-[#5C6B61] max-w-xl">
              Hai fatto tante visite? Ti hanno detto che non è possibile mettere un impianto dentale?
              Non devi disperare: con la <strong className="text-[#15201A]">griglia iuxtaossea</strong> e gli{" "}
              <strong className="text-[#15201A]">impianti zigomatici</strong> garantiamo una dentatura fissa
              anche ai pazienti con poco osso o senza osso. Per gli interventi più complessi in anestesia
              generale è attiva la <strong className="text-[#15201A]">convenzione con una struttura in
              Day Surgery</strong> attrezzata e con degenza (costo a parte).
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 grid grid-cols-2 gap-4">
              <img
                src="https://static.prod-images.emergentagent.com/jobs/c24763e7-4110-455f-bc22-09e351652797/images/085b784d62d5490b47f21d436b74523514bda79a67ff846437ad429bef4f48d1.jpeg"
                alt="Griglia iuxtaossea in titanio personalizzata su modello osseo"
                loading="lazy"
                decoding="async"
                className="rounded-[32px] rounded-br-none w-full h-64 object-cover"
              />
              <img
                src="https://static.prod-images.emergentagent.com/jobs/c24763e7-4110-455f-bc22-09e351652797/images/c40a344b61de61319020725663afa5bf37373f2688e1759a8cfbf85de8a1fa7f.jpeg"
                alt="Impianti zigomatici su modello anatomico del cranio"
                loading="lazy"
                decoding="async"
                className="rounded-[32px] rounded-bl-none w-full h-64 object-cover"
                data-testid="zygomatic-implants-img"
              />
            </div>
          </Reveal>
          <Reveal delay={0.25}>
            <ul className="mt-8 space-y-3">
              {advantages.map((a) => (
                <li key={a} className="flex items-start gap-3 text-[#15201A] font-semibold">
                  <span className="mt-0.5 flex-shrink-0 w-6 h-6 rounded-full bg-[#385244]/10 flex items-center justify-center">
                    <Check size={14} className="text-[#385244]" />
                  </span>
                  {a}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
        <div className="lg:sticky lg:top-32">
          <Reveal delay={0.1}>
            <div className="bg-white border border-border rounded-[32px] p-8 md:p-10">
              <h3 className="font-serif-display text-2xl md:text-3xl text-[#15201A]">Come funziona, passo per passo</h3>
              <ol className="mt-8 space-y-6">
                {steps.map((s) => (
                  <li key={s.n} className="flex gap-5">
                    <span className="font-serif-display font-light text-4xl text-[#385244]/25 leading-none flex-shrink-0 w-8">{s.n}</span>
                    <p className="text-base leading-relaxed text-[#5C6B61]">{s.text}</p>
                  </li>
                ))}
              </ol>
              <a
                href="#contatti"
                className="mt-10 inline-flex items-center rounded-full bg-[#C98E6E] hover:bg-[#B37A5B] text-white font-bold px-8 py-4 transition-colors duration-300 active:scale-95"
                data-testid="bone-cta-btn"
              >
                Chiedi una valutazione
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
